<script lang="ts">
	//Design System
	import { Input, Text } from '@Shelly/shelly-design-system';
	//Helpers
	import { format } from 'svelte-i18n';

	//Props
	export let sceneData: any = {};
	export let active = { operator: '', value: '' };
	export let input_text = '';
	export let config;
	export let id = '',
		icon = '',
		sensor_name,
		add_info_ind,
		input_index;

	//Validation props
	export let invalidInputError: boolean = false;
	export let valueOutOfRange: boolean = false;

	// Handler props
	export let handle_condition_threshold: (item: any) => void;
	export let validateWizardDeviceCondition: () => void;

	//Computed
	$: icon = icon || 'fa-text';

	const validateInputText = () => {
		invalidInputError = false;
		valueOutOfRange = `${input_text}`.length > config?.max_length;
	};

	function handleInputTextError(value) {
		if (valueOutOfRange) {
			let length = value?.length || 0;
			let min = 0;
			let max = config?.max_length;
			return $format('error_text_out_of_range', {
				default: `Value (${length} characters) is out of range. Please provide a value within the limits. (${min} — ${max} characters)`,
				values: {
					length,
					min,
					max,
				},
			});
		}
	}

	const handle_input_text = (value: string): void => {
		input_text = value;
		validateInputText();
		validateWizardDeviceCondition();

		handle_condition_threshold({
			id,
			operator: 'equal',
			value: input_text,
			sensor_name,
			add_info_ind,
			input_index,
		});
	};

	//Handle input text on condition load
	let current_condition = sceneData._device_condition;
	if (current_condition?.cond_name === id && current_condition?.input_index === input_index) {
		// Process empty text input by default
		handle_input_text(active?.operator ? active?.value || '' : '');
	}
</script>

<Text class="mt-l mb-s" styleType="h2">
	{$format('title_scene_condition_with_input', {
		default: `When {value} is`,
		values: { value: sceneData?.selectedDeviceProp?.title },
	})}
</Text>
<div class="d-flex mt-s">
	<Input
		aria-labelledby="input-o3q85yi"
		class="mt-s"
		size="m"
		{icon}
		label={input_text}
		value={active?.operator ? active?.value : ''}
		error={handleInputTextError(input_text)}
		on:input={(e) => handle_input_text(e.target?.value)}
		id="input-o3q85yi"
	/>
</div>
